import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import HelpIcon from '@material-ui/icons/Help';

import { MEDIUM_SOY } from 'bento-ordering/base/constants/colors';

const StyledToolTip = withStyles({
  tooltip: {
    backgroundColor: MEDIUM_SOY,
    maxWidth: 200,
    position: 'relative'
  }
})(Tooltip);

const SmallHelpIcon = withStyles({
  fontSizeSmall: {
    fontSize: 16
  }
})(HelpIcon);

const ToolTipArrow = styled.span`
  position: absolute;
  font-size: 6px;
  top: -6px;
  left: calc(50% - 10px);
  margin: auto;
  width: 20px;
  height: 10px;

  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-color: transparent transparent ${MEDIUM_SOY} transparent;
    border-width: 0 10px 10px 10px;
  }
`;

const getTooltipContentWithArrow = content => (
  <Box data-testid="help-tooltip-container">
    <ToolTipArrow />
    {content}
  </Box>
);

const HelpToolTip = ({ children, ...rest }) => {
  return (
    <StyledToolTip
      title={getTooltipContentWithArrow(children)}
      {...rest}
      enterTouchDelay={0}
    >
      <IconButton size="small">
        <SmallHelpIcon fontSize="small" />
      </IconButton>
    </StyledToolTip>
  );
};

HelpToolTip.propTypes = {
  children: PropTypes.node
};

export default HelpToolTip;
